import { Component, HostBinding, Input, OnInit, inject } from '@angular/core';

import { tap } from 'rxjs';

import { BannerLayoutType, MiniTeaserBanner } from '@hdms/shared/common-types';
import { BannerHelperService, BannerService, ProductBanner } from '@hdms/shared/data-access';
import { ProductMenuType, SecondaryNavGroup } from '@hdms/shared/page-frame/types';
import { BannerSize } from '@hdms/shared/ui-core';

@Component({
  selector: 'shrd-pf-ui-product-menu-links',
  templateUrl: './header-product-menu-links.component.html',
  styleUrls: ['./header-product-menu-links.component.scss']
})
export class HeaderProductMenuLinksComponent implements OnInit {
  readonly productMenuType = ProductMenuType;
  readonly bannerLayout = BannerLayoutType;
  bannerSize: BannerSize;

  @HostBinding('class.content-box')
  @Input()
  inFlyout = false;

  @Input() menuTitle?: string;

  categories: SecondaryNavGroup;

  private readonly bannerService = inject(BannerService);
  private readonly bannerHelperService = inject(BannerHelperService);

  readonly teasers$ = this.bannerService.megaMenuMiniTeaserBanners$;
  readonly banner$ = this.bannerService.megaMenuProductBanner$.pipe(
    tap(
      banner =>
        banner.loaded &&
        this.bannerHelperService.trackBannerImpression(banner, this.getAdditionalProductBannerTrackingData(banner))
    )
  );

  @Input() set menuItems(groups: SecondaryNavGroup[]) {
    this.categories = groups.find(g => g.menuType === ProductMenuType.CATEGORY);
  }

  ngOnInit(): void {
    this.bannerSize = this.inFlyout ? BannerSize.MD : BannerSize.XS;
  }

  trackBannerClick(banner: ProductBanner): void {
    this.bannerHelperService.trackBannerClick(banner, this.getAdditionalProductBannerTrackingData(banner));
  }

  trackTeaserClick(teaser: MiniTeaserBanner): void {
    this.bannerHelperService.trackMiniTeaserBannerClick(teaser);
  }

  private getAdditionalProductBannerTrackingData(banner: ProductBanner): Record<string, string> {
    return { creative: `${banner.webAnalyticsData?.trackCreative}_${this.bannerSize}` };
  }
}
